import { Component, ChangeDetectionStrategy } from '@angular/core';

/** `<sui-menu-header>` — a non-interactive label for a group of menu items. */
@Component({
  selector: 'sui-menu-header',
  standalone: true,
  template: '<ng-content />',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        display: block;
        padding: var(--space-4) var(--space-12);
        font-family: var(--font-family-sans);
        font-size: var(--font-size-12);
        font-weight: var(--font-weight-semibold);
        line-height: var(--font-line-height-normal);
        color: var(--menu-header-text);
      }
    `,
  ],
})
export class SuiMenuHeaderComponent {}
